import React, { useCallback } from 'react';
import { Icon } from 'panamera-react-ui';
import { withRouter } from "../../Helpers/withRouter";
var css = {
  "navigationHeader": "oalp-2vG32"
};
export var NaviagtionHeader = function NaviagtionHeader(_ref) {
  var _ref$showBackButton = _ref.showBackButton,
    showBackButton = _ref$showBackButton === void 0 ? false : _ref$showBackButton,
    _ref$closeButton = _ref.closeButton,
    _ref$closeButton2 = _ref$closeButton === void 0 ? {} : _ref$closeButton,
    _ref$closeButton2$act = _ref$closeButton2.action,
    closeAction = _ref$closeButton2$act === void 0 ? '' : _ref$closeButton2$act,
    router = _ref.router;
  var onCloseClick = useCallback(function () {
    router === null || router === void 0 ? void 0 : router.push(closeAction);
  }, [closeAction, router]);
  var onBackClick = useCallback(function () {
    router === null || router === void 0 ? void 0 : router.goBack();
  }, [router]);
  return /*#__PURE__*/React.createElement("div", {
    className: css.navigationHeader
  }, showBackButton && /*#__PURE__*/React.createElement("div", {
    onClick: onBackClick,
    className: "back"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 24,
    icon: "back"
  })), closeAction && /*#__PURE__*/React.createElement("div", {
    onClick: onCloseClick,
    className: "close"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 24,
    icon: "cross"
  })));
};
export default withRouter(NaviagtionHeader);